export function timeAgo(pastTimeString) {
    // Convert the past time string to a Date object
    var pastDate = new Date(pastTimeString);

    // Get the current date and time
    var currentDate = new Date();

    // Calculate the difference in milliseconds
    var timeDifference = currentDate - pastDate;

    // Convert milliseconds to seconds
    var secondsDifference = Math.floor(timeDifference / 1000);

    // Define time units
    var secondsInMinute = 60;
    var secondsInHour = 3600;
    var secondsInDay = 86400;
    var secondsInMonth = 2592000;
    var secondsInYear = 31536000;

    // Calculate the "ago" time
    if (secondsDifference < secondsInMinute) {
        return secondsDifference + " sec";
    } else if (secondsDifference < secondsInHour) {
        var minutes = Math.floor(secondsDifference / secondsInMinute);
        return minutes + " min";
    } else if (secondsDifference < secondsInDay) {
        var hours = Math.floor(secondsDifference / secondsInHour);
        return hours + " hr";
    } else if (secondsDifference < secondsInMonth) {
        var days = Math.floor(secondsDifference / secondsInDay);
        return days + " d ago";
    } else if (secondsDifference < secondsInYear) {
        var months = Math.floor(secondsDifference / secondsInMonth);
        return months + " months ago";
    } else {
        var years = Math.floor(secondsDifference / secondsInYear);
        return years + " years ago";
    }
}


